export default __webpack_public_path__ + "static/media/0045.10be6d64.jpg";